/**
 * @namespace Base64Helper 
 */

const Base64Helper = {
    /**
     * Convert Bas64 to Blob object
     * @param {string } base64String Image in base64 format
     * @returns {object}  Blob file-like object of immutable, raw data
     */
    convertBas64ToBlob(base64String) {
        let blob = null;
        let contentType = this.getType(base64String);
        if (contentType) {
            const byteCharacters = atob(base64String);
            const byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
                const slice = byteCharacters.slice(offset, offset + 1024);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }
            blob = new Blob(byteArrays, { type: contentType });
        }
        return blob;
    },
    /**
     * Open base 64 image in browser window
     * @param {string } base64String Image in base64 format
     * @param {string } target A string, without whitespace, specifying the name of the browsing context the resource is being loaded into. If the name doesn't identify an existing context, a new context is created and given the specified name. The special target keywords, _self, _blank, _parent, and _top, can also be used.
     * 
     * @returns {object} The reference to the browser window where base64 image should be
     */
    openBase64Image(base64String, window) {
        try {
            const blob = Base64Helper.convertBas64ToBlob(base64String);
            if (blob) {
                const blobUrl = URL.createObjectURL(blob);
                window.location = blobUrl;
            } else {
                window.close();
            }
        } catch {
            window.close();
        }
    },

    /**
     * Returns base64 image contnent type
     * @param {string } base64String Image in base64 format
     * 
     * @returns {string} base64 image contnent type
     */
    getType(base64String) {
        if (base64String) {
            // Remove the data prefix if present
            const base64WithoutPrefix = base64String.replace(/^data:[^;]*;base64,/, '');

            // Map of magic numbers to content types
            var signatures = {
                JVBERi0: "application/pdf",
                R0lGODdh: "image/gif",
                R0lGODlh: "image/gif",
                iVBORw0KGgo: "image/png",
                "/9j/": "image/jpg"
            }

            // Check if the magic number matches any known content type
            for (const sgn in signatures) {
                if (base64WithoutPrefix.startsWith(sgn)) {
                    return signatures[sgn];
                }
            }
        }

        // If no match is found, return null
        return null;
    },
    /**
     * Checks if string is in base64 format
     * @param {string } string Given string
     * 
     * @returns {Boolean} Is the given string in base64 format
     */
    isBase64(str) {
        if (typeof str !== 'string' || str === '' || str.trim() === '') { return false; }
        try {
            return btoa(atob(str)) === str;
        } catch (err) {
            return false;
        }
    },
    encode(input) {
        const utf8Bytes = new TextEncoder().encode(input);
        const base64String = btoa(String.fromCharCode(...utf8Bytes));

        return base64String
            .replace(/\+/g, '-')  // Replace '+' with '-'
            .replace(/\//g, '_')  // Replace '/' with '_'
            .replace(/=+$/, '');  // Remove trailing '=' padding
    },
    decode(input) {
        let base64 = input
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        // Pad with '=' to make length a multiple of 4
        while (base64.length % 4 !== 0) {
            base64 += '=';
        }
        return atob(base64);
    }

}

export default Base64Helper;